<!-- .nav-item from bootstrap and scss/_nav.scss -->
<div class="nav-item">
    <!-- .cmps-nav-icon from bootstrap and scss/_nav.scss -->
    <button
        class="cmps-icon-button--no-bg cmps-icon-button--no-bg--white cmps-nav-icon cmps-teamscall-chat-menu-nav-button--button"
        [class.active]="_dialogService.isOpen"
        cmpsIconButton
        tabindex="0"
        role="menuitem"
        (click)="_dialogService.toggle()"
    >
        <div
            class="cmps-teamscall-chat-menu-nav-button--tooltip"
            [cmpsTooltipTrigger]="_i18n._11163_LAUNCH_CHAT_MENU | translate"
            placement="bottom-center"
            [openDelay]="1000"
        ></div>

        <!-- TODO revise padding after all nav icons have changed to mdi (cmps-icon) icons -->
        <div class="cmps-cdk-pt-0dot25">
            <cmps-icon svgIcon="chat-outline"></cmps-icon>
        </div>

        <!-- .line from scss/_nav.scss -->
        <div class="line"></div>
    </button>
</div>
